/**
 * The customiser PANEL's own light/dark scheme — nothing to do with the
 * site's palette the editor is editing. The panel's colours are the
 * headless design system's tokens (src/theme/headless/), which flip with
 * the `data-theme` lib/theme.tsx stamps from this preference; the
 * accents are the system's too (steel for selection and focus, the
 * status colours for status), never a literal.
 *
 * Preference: 'system' follows prefers-color-scheme; 'light'/'dark' pin
 * it. Stored per browser in localStorage (PANEL_THEME_KEY) — a viewer
 * convenience, never config. Nothing stored is 'dark': the headless
 * design system is dark first, so 'system' is now a choice that is
 * stored like the other two (a stored 'light' or 'dark' from before
 * carries over unchanged).
 */
export type PanelTheme = 'system' | 'light' | 'dark';
const PANEL_THEME_KEY = 'cz-theme';
/** No stored preference: dark first (the headless design system). */
const DEFAULT_PANEL_THEME: PanelTheme = 'dark';

export function readPanelTheme(): PanelTheme {
  try {
    const v = localStorage.getItem(PANEL_THEME_KEY);
    return v === 'light' || v === 'dark' || v === 'system' ? v : DEFAULT_PANEL_THEME;
  } catch { return DEFAULT_PANEL_THEME; }
}
export function writePanelTheme(t: PanelTheme): void {
  try { localStorage.setItem(PANEL_THEME_KEY, t); } catch { /* private mode */ }
}
// The token values live in src/theme/headless/headless.css (`.cz-root`,
// re-pointed at the headless tokens) and src/index.css makes them `cz-*`
// colours; this module only owns the stored preference.
